import { useQuery } from "@tanstack/react-query";
import { getEnv } from "../../../../AppConfigs";
import { DocumentService } from "../../../../services/document/document.service";
import { useSearchParams } from "../../../../hook/use-search-params";
import { getUCTDate } from "../../../../helper/dateTimeHelper";

export const useDocumentExpired = () => {
  const listId = getEnv("REACT_APP_PUBLIC_FOLDER_AND_FILE_SP_LIST_ID");
  const today = getUCTDate(new Date());
  const { searchParams } = useSearchParams();
  const status = searchParams.get("status");
  const isExpired = !!searchParams.get("filter-expired");

  const { data, isLoading } = useQuery({
    queryKey: ["document-expired"],
    queryFn: () => DocumentService.getPublicExpiredDocumentInfoFromWorkingDocument(today, listId),
    enabled: status === "publish" && isExpired,
  });

  return { data, isLoading };
};
